import React from "react";

const PillButton = ({
  text,
  handleClick,
  icon = "",
  classnames = "",
  styles = {},
}) => {
  return (
    <button
      styles={styles}
      className={`pill-btn-blue ${classnames}`}
      onClick={handleClick}
    >
      {text}
      {icon}
    </button>
  );
};

export default PillButton;
